var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 13.8889C17.5506 13.8889 16.2202 13.6828 14.9446 13.278C14.5556 13.1668 14.1113 13.2221 13.8336 13.5558L11.3889 15.9999C8.22208 14.3891 5.66677 11.8333 4.05542 8.66646L6.50016 6.22234C6.77786 5.94458 6.8888 5.50026 6.77786 5.11125C6.33323 3.83359 6.11109 2.5 6.11109 1.11109C6.11109 0.500208 5.61115 0 5 0H1.11109C0.499948 0 0 0.500208 0 1.11109C0 11.5554 8.44458 20 18.8889 20C19.4998 20 20 19.4998 20 18.8889V15C20 14.3891 19.4998 13.8889 18.8889 13.8889Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.640c666fe72a27b6ff13d5871407ddfa.svg";
export { ForwardRef as ReactComponent };